import digitalEmpire1 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-1@2x.png";
import digitalEmpire2 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-2@2x.png";
import digitalEmpire3 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-3@2x.png";
import digitalEmpire4 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-4@2x.png";
import digitalEmpire5 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-5@2x.png";
import digitalEmpire6 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-6@2x.png";
import digitalEmpire7 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-7@2x.png";
import digitalEmpire8 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-8@2x.png";
import digitalEmpire9 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-9@2x.png";
import digitalEmpire10 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-10@2x.png";
import digitalEmpire11 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-11@2x.png";
import digitalEmpire12 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-12@2x.png";
import digitalEmpire13 from "common-modules/general/assets/Desktop/images/footer/digital-empire-big-13@2x.png";

import digitalEmpireSmall1 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-1@2x.png";
import digitalEmpireSmall2 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-2@2x.png";
import digitalEmpireSmall3 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-3@2x.png";
import digitalEmpireSmall4 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-4@2x.png";
import digitalEmpireSmall5 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-5@2x.png";
import digitalEmpireSmall6 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-6@2x.png";
import digitalEmpireSmall7 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-7@2x.png";
import digitalEmpireSmall8 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-8@2x.png";
import digitalEmpireSmall9 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-9@2x.png";
import digitalEmpireSmall10 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-10@2x.png";
import digitalEmpireSmall11 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-11@2x.png";
import digitalEmpireSmall12 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-12@2x.png";
import digitalEmpireSmall13 from "common-modules/general/assets/Desktop/images/footer/digital-empire-small-13@2x.png";

// 공사중인 사업지
export const ingData = [];

// 공사 완료 사업지 리스트
export const complateData = [
  {
    id: 1,
    name: "안산 스마트 스퀘어 지식산업센터",
    desc: "지독하게, 집요하게 수요자를 배려하다 안산 스마트허브 맨앞자리 지식산업센터에 주목하라!",
    address: "경기도 안산시 단원구 신길동 1229",
    period: "2018.09 ~ 2020.09",
    bArea: "26,082.09㎡", // 건축면적
    gArea: "194,365.06㎡", // 연면적
    floorRatio: "349.28%",
    place:
      "지하 1층 ~ 지상 13층, 1개동 지식산업센터(887실) : 2F~13F 근린생활시설(452실) : 1F~2F",
    phone: "",
    imgLarge: digitalEmpire1,
    imgSmall: digitalEmpireSmall1,
  },
  {
    id: 2,
    name: "평촌 디지털 엠파이어",
    desc: "성공을 한 발 먼저 만나는 안양벤처밸리의 랜드마크",
    address: "경기도 안양시 동안도 관양2동 954-2번지외 1필지",
    period: "2016.5 ~ 2018.2",
    bArea: "5,450㎡", // 건축면적
    gArea: "51,145㎡", // 연면적
    floorRatio: "344.98%",
    place: "지하3층 ~ 지상13층 1개동",
    phone: "",
    imgLarge: digitalEmpire2,
    imgSmall: digitalEmpireSmall2,
  },
  {
    id: 3,
    name: "블루텍",
    desc: "제조업 비니지스의 새로운 패러다임",
    address: "인천시 서구 오류동 1656-1 (검단일반산업단지 내)",
    period: "2014.10 ~ 2016.9",
    bArea: "17.768.24㎡", // 건축면적
    gArea: "151.935.50㎡", // 연면적
    floorRatio: "348.05%",
    place:
      "공장동 - 지하2층 ~ 지상11층 1개동 지원동 - 지하2층 ~ 지상15층 1개동",
    phone: "",
    imgLarge: digitalEmpire3,
    imgSmall: digitalEmpireSmall3,
  },
  {
    id: 4,
    name: "인덕원 디지털 엠파이어",
    desc: "안양벤처밸리 내 독립형 오너십 오피스형 공장",
    address: "경기도 안양시 동안구 관양동 906-1번지 외 6필지",
    period: "2014.10 ~ 2016.9",
    bArea: "4598.48㎡", // 건축면적
    gArea: "45.399.45㎡", // 연면적
    floorRatio: "348.05%",
    place: "지하3층, 지상13층",
    phone: "",
    imgLarge: digitalEmpire4,
    imgSmall: digitalEmpireSmall4,
  },
  {
    id: 5,
    name: "가산 디지털 엠파이어",
    desc: "디지털 엠파이어 성공의 중심에 서다",
    address: "서울시 금천구 가산동 685번지",
    period: "2008.3 ~ 2010.3",
    bArea: "2813.46㎡", // 건축면적
    gArea: "47.226.8㎡", // 연면적
    floorRatio: "479.48%",
    place: "지하3층, 지상15층",
    phone: "",
    imgLarge: digitalEmpire5,
    imgSmall: digitalEmpireSmall5,
  },
  {
    id: 6,
    name: "부천 춘의 테크노파크II",
    desc: "기업을 키우는 부천, 기업이 커가는 테크노파크2",
    address: "부천시 원미구 춘의동 202",
    period: "2008.3 ~ 2010.3",
    bArea: "4646.73㎡", // 건축면적
    gArea: "77.648.32㎡", // 연면적
    floorRatio: "476.08%",
    place: "지하2층, 지상15층(2개동)",
    phone: "",
    imgLarge: digitalEmpire6,
    imgSmall: digitalEmpireSmall6,
  },
  {
    id: 7,
    name: "수원 영통 디지털 엠파이어I",
    desc: "연면적 4만 8천평에 5개동 타워형 비지니스센터",
    address: "수원시 영통구 여통동 890-3번지",
    period: "2004.4 ~ 2006.8",
    bArea: "11.244.12㎡", // 건축면적
    gArea: "158.646.57㎡", // 연면적
    floorRatio: "641.32%",
    place: "지하2층, 지상14층(5개동)",
    phone: "",
    imgLarge: digitalEmpire7,
    imgSmall: digitalEmpireSmall7,
  },
  {
    id: 8,
    name: "부천 춘의 테크노파크I",
    desc: "최적의 인프라, Dream Factory",
    address: "수원시 영통구 여통동 890-3번지",
    period: "2004.1 ~ 2005.10",
    bArea: "5.356.66㎡", // 건축면적
    gArea: "84.752.94㎡", // 연면적
    floorRatio: "474.22%",
    place: "지하2층, 지상15층(2개동)",
    phone: "",
    imgLarge: digitalEmpire8,
    imgSmall: digitalEmpireSmall8,
  },
  {
    id: 9,
    name: "부천 테크노파크II",
    desc: "부천시의 새로운 성장동력, 부천 테크노파크 4단지",
    address: "부천시 원미구 약대동 193번지 (4단지)",
    period: "2001.12 ~ 2004.5",
    bArea: "8.670.57㎡", // 건축면적
    gArea: "76.771.36㎡", // 연면적
    floorRatio: "241.86%",
    place: "지하2층, 지상15층(2개동)",
    phone: "",
    imgLarge: digitalEmpire9,
    imgSmall: digitalEmpireSmall9,
  },
  {
    id: 10,
    name: "고려 테크온",
    desc: "고려 테크온에는 성공투자의 분명한 이유가 있습니다",
    address: "부천시 원미구 약대동 193번지 (4단지)",
    period: "2003.1 ~ 2004.4",
    bArea: "1.511.215㎡", // 건축면적
    gArea: "13.910㎡", // 연면적
    floorRatio: "399.40%",
    place: "지하2층, 지상7층(1개동)",
    phone: "",
    imgLarge: digitalEmpire10,
    imgSmall: digitalEmpireSmall10,
  },
  {
    id: 11,
    name: "부천 테크노파크I",
    desc: "부천시의 새로운 성장동력, 부천 테크노파크 3단지",
    address: "부천시 원미구 약대동 193번지 (4단지)",
    period: "2001.12 ~ 2004.5",
    bArea: "17.937.90㎡", // 건축면적
    gArea: "122.080.79㎡", // 연면적
    floorRatio: "221.70%",
    place: "지하1층, 지상15층",
    phone: "",
    imgLarge: digitalEmpire11,
    imgSmall: digitalEmpireSmall11,
  },
  {
    id: 12,
    name: "인천 마크원 복합비즈센터",
    desc: "변화하는 남동국가산업단지의 미래가치 변화의 중심 남동 최대규모 마크원 지식산업센터!",
    address: "인천광역시 남동구 고잔동 649-3",
    period: "2019.07.~2021.10(예정)",
    bArea: "9,518.45㎡", // 건축면적
    gArea: "87,747.62㎡", // 연면적
    floorRatio: "419.81%",
    place:
      "지하 1층 ~ 지상 15층, 1개동 지식산업센터(403실) : B1F~15F 오피스텔(150실) : 4F~13F 근린생활시설(52개) : B1F~3F",
    phone: "1577-1434",
    imgLarge: digitalEmpire12,
    imgSmall: digitalEmpireSmall12,
  },
  {
    id: 13,
    name: "수원 신동 디지털 엠파이어",
    desc: "Together 세계인류, 디지털엠파이어2",
    address: "수원시 영통구 신동 486번지",
    period: "2006.4 ~ 2008.6",
    bArea: "12.352.13㎡", // 건축면적
    gArea: "142.435.50㎡", // 연면적
    floorRatio: "348.12%",
    place: "지하2층 ~ 지상15층 (3개동 외 부대시설)",
    phone: "02-2170-5575",
    imgLarge: digitalEmpire13,
    imgSmall: digitalEmpireSmall13,
  },
];
